import { createSelector } from 'reselect';

const selectRegistration = state => state.registration;

export const getToken = () => createSelector(selectRegistration, x => x.token);
export const getIsRegistered = () => createSelector(selectRegistration, x => x.isRegistered);
export const getIsErr = () => createSelector(selectRegistration, x => x.isErr);
export const getIsConfirmed = () => createSelector(selectRegistration, x => x.isConfirmed);

